import React from "react";
import "./NewsRoomContent.scss";
import BannerType1 from "../../../../components/BannerType1";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const NewsRoomContent = () => {
  const { t } = useTranslation();
  const langNavigate = useLangNavigate();
  const handleNews = (index: string) => {
    langNavigate(`news/press/${index}`);
  };
  const news = t("news", { returnObjects: true }) as { path: string; title: string; date: string; des: string }[];
  return (
    <>
      <div id="news_room_content_wrap">
        <BannerType1 path="/imgs/banner_news_room.png" />
        <h2 className="title">{t("newsEducation.newsRoom.pressRelease.title")}</h2>
        <div className="contents">
          {news &&
            news.map((content: { path: string; title: string; date: string; des: any }, index: number) => {
              return (
                <div
                  id={`${index}`}
                  className="card"
                  key={`${content.title}_${index}`}
                  onClick={() => {
                    handleNews(String(index));
                  }}
                >
                  <div className="img_box">
                    <img src={`${content.path}`} alt={`${content.title}`} />
                  </div>
                  <div className="name">{content.title}</div>
                  <div className="date">{content.date}</div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default NewsRoomContent;
